export default {
  root: {
    fontWeight: 700,
    textTransform: 'none',
    padding: '12px 24px'
  },
  contained: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(246, 23, 102, 0.24)'
    },
    '&:active': {
      boxShadow: 'none'
    }
  },
  containedPrimary: {
    backgroundColor: '#FF2D47',
    '&:hover': {
      backgroundColor: '#E02640'
    }
  },
  containedSecondary: {
    backgroundColor: '#D01A7F',
    '&:hover': {
      backgroundColor: '#A8145F'
    }
  },
  outlined: {
    borderWidth: 2,
    padding: '10px 22px',
    '&:hover': {
      borderWidth: 2
    }
  },
  outlinedPrimary: {
    borderColor: '#FF2D47',
    color: '#FF2D47',
    '&:hover': {
      borderColor: '#E02640',
      backgroundColor: 'rgba(255, 45, 71, 0.08)'
    }
  },
  text: {
    padding: '12px 16px'
  },
  sizeLarge: {
    padding: '16px 32px',
    fontSize: '16px'
  },
  sizeSmall: {
    padding: '8px 16px',
    fontSize: '12px'
  }
};
